module.exports = __webpack_public_path__ + "img/nodata1.1b3a6ed1.png";